import styled from "styled-components";
import {brand, fontFamilies, motion, radii} from "theme/tokens";
import {UpgradeDialog} from "upsell/CompactUpgradeDialog.styles";

/**
 * Externalized styles for {@link ./OverLimitCheckoutDialog}, the over-limit pay dialog
 * (kitecorp/transferify-ui#3229), built from the owner's approved prototype of 2026-10-03.
 *
 * <b>It wears the compact upgrade dialog's shell</b> ({@link upsell/CompactUpgradeDialog.styles}): the same 720px
 * card, the same artwork column for the plan on offer, the same bottom sheet under the sheet breakpoint, and the
 * same ✕. The owner asked for the dialog "laid out like the compact single-plan upgrade dialog", and one shell
 * is what keeps the two from drifting apart. What is defined here is only what that shell does not have: the
 * title and lede above the rows, and the Continue under them.
 */

export const PayDialog = styled(UpgradeDialog)`
	& .MuiPaper-root {
		width: 720px;
	}
`;

/** The dialog's heading, with room kept for the ✕ above it, as the compact dialog's plan name keeps it. */
export const Title = styled.h2`
	margin: 0 0 4px;
	padding-right: 44px;
	font-size: 19px;
	font-weight: 700;
	letter-spacing: -0.01em;
	line-height: 1.3;
	color: ${({theme}) => theme.tokens.ink};
`;

export const Lede = styled.p`
	margin: 0 0 18px;
	padding-right: 20px;
	font-size: 14px;
	line-height: 1.45;
	color: ${({theme}) => theme.tokens.ink2};
`;

/** Terms: the sized dialog's one line of price and renewal terms, above the press, said once for every row. */
export const Terms = styled.p`
	margin: 14px 0 12px;
	font-size: 13px;
	line-height: 1.45;
	color: ${({theme}) => theme.tokens.ink2};
`;

/** Continue: the compact dialog's own primary control, so the two dialogs' one CTA is one recipe. */
export const Continue = styled.button`
	width: 100%;
	min-height: 44px;
	padding: 13px 16px;
	border: none;
	border-radius: ${radii.control};
	cursor: pointer;
	font-family: ${fontFamilies.sans};
	font-size: 15px;
	font-weight: 600;
	background: ${({theme}) => theme.tokens.blue};
	color: ${({theme}) => theme.tokens.mode === "dark" ? brand.navy : brand.white};
	transition: background ${motion.hover} ${motion.easeOut};

	&:not(:disabled):hover {
		background: ${({theme}) => theme.tokens.blued};
	}

	&:disabled {
		cursor: default;
		opacity: 0.6;
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}
`;
